import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { TranslationService } from '../../Services/translation.service';
import { HelperService } from '../../Services/helper.service';
import { platformBrowser } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'zav-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit {
  // Language
  word: any = {};
  language: string = '';
  // City
  city: string = '';
  currentCity: string = '';
  isOutside: boolean = false;
  bookyCities: string[] = ['skopje', 'beograd'];

  constructor(
    @Inject(PLATFORM_ID) private platformId,
    private translationService: TranslationService,
    private helperService: HelperService
  ) {
  }

  ngOnInit(): void {
    this.word = this.translationService.word;
    this.language = this.translationService.language;
    this.city = this.helperService.getCity();
    this.isOutside = this.bookyCities.includes(this.city);

    if(isPlatformBrowser(this.platformId)){
      switch (window.location.host) {
        case 'booky.mk':
          this.currentCity = 'skopje'
          this.isOutside = true;
          break;
        case 'booknow.rs':
          this.currentCity = 'beograd'
          this.isOutside = true;
          break;
        default:
          this.currentCity = this.city;
          this.isOutside = false;
          break;
      }
    }
  }
}
